import { bulkUpdateReservedInventoryBuckets } from "./schema/reserved-inventory-buckets/bulk-update-reserved-inventory-buckets";
import { createCustomReservedInventoryBucketType } from "./schema/reserved-inventory-buckets/create-custom-reserved-inventory-bucket-type";
import { deleteCustomReservedInventoryBucketType } from "./schema/reserved-inventory-buckets/delete-custom-reserved-inventory-bucket-type";
import { getReservedInventoryBuckets } from "./schema/reserved-inventory-buckets/get-reserved-inventory-buckets";
import { listCustomReservedInventoryBucketTypes } from "./schema/reserved-inventory-buckets/list-custom-reserved-inventory-bucket-types";
import { updateCustomReservedInventoryBucketType } from "./schema/reserved-inventory-buckets/update-custom-reserved-inventory-bucket-type";
import { updateReservedInventoryBucket } from "./schema/reserved-inventory-buckets/update-reserved-inventory-bucket";

export const groupL: {
  bulkUpdateReservedInventoryBuckets: typeof bulkUpdateReservedInventoryBuckets;
  createCustomReservedInventoryBucketType: typeof createCustomReservedInventoryBucketType;
  deleteCustomReservedInventoryBucketType: typeof deleteCustomReservedInventoryBucketType;
  getReservedInventoryBuckets: typeof getReservedInventoryBuckets;
  listCustomReservedInventoryBucketTypes: typeof listCustomReservedInventoryBucketTypes;
  updateCustomReservedInventoryBucketType: typeof updateCustomReservedInventoryBucketType;
  updateReservedInventoryBucket: typeof updateReservedInventoryBucket;
} = {
  bulkUpdateReservedInventoryBuckets,
  createCustomReservedInventoryBucketType,
  deleteCustomReservedInventoryBucketType,
  getReservedInventoryBuckets,
  listCustomReservedInventoryBucketTypes,
  updateCustomReservedInventoryBucketType,
  updateReservedInventoryBucket,
};
